export enum TestIds {
    FLOATING_ROW_HEADER = 'floating-row-header',
}
